import { atom } from "recoil";

// current

export const currentFloorMoveState = atom<"ANY" | "EV" | "ES" | "STEP">({
    key: "currentFloorMoveState",
    default: "ANY",
});
